import React from 'react';
import { Card } from 'antd';

const ProductCard = ({ product, loading }) => {
  return (
    <Card
      loading={loading}
      hoverable
      style={{
        // width: 230,
        height: 150,
        // position: 'relative',
      }}
      // cover={
      //   <div style={{ textAlign: 'center', padding: '10px' }}>
      //     <img
      //       alt={product.productName}
      //       src={image}
      //       style={{
      //         maxWidth: '100%',
      //         width: '150px',
      //         height: 'auto',
      //         maxHeight: '180px',
      //         padding: '10px',
      //       }}
      //     />
      //   </div>
      // }
    >
      <div
        style={{
          position: 'absolute',
          top: 10,
          left: 10,
          backgroundColor: '#6571ff',
          color: '#fff',
          padding: '5px',
          borderRadius: '4px',
        }}
      >
        {`$ ${product.productCost}`}
      </div>
      <div
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          backgroundColor: '#6571ff',
          color: '#fff',
          padding: '5px',
          borderRadius: '4px',
        }}
      >
        {`${product.totalStockQty} piece`}
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: 5,
          left: 5,
          color: '#000',
          padding: '5px',
          borderRadius: '4px',
        }}
      >
        <div style={{ fontWeight: '600', color: '#000' }}>{product.productName}</div>
        <div>Code: {product.productCode}</div>
      </div>
    </Card>
  );
};

export default ProductCard;
